import { render } from "./CYWNvirtualCommerce.vue?vue&type=template&id=5b06ade8&scoped=true"
import script from "./CYWNvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./CYWNvirtualCommerce.vue?vue&type=script&lang=js"

import "./CYWNvirtualCommerce.vue?vue&type=style&index=0&id=5b06ade8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b06ade8"

export default script